import React from 'react';
import propTypes from 'prop-types';

import { scriptConfigViews } from 'constants/values';

import ScriptConfigInputs from 'edit/ScriptConfigInputs';
import ScriptConfigSummary from 'edit/ScriptConfigSummary';

const ScriptConfig = ({
  applicationType,
  displayScriptName,
  hasNitrapyrin,
  maxDate,
  minDate,
  onChangeNitrapyrin,
  onChangePlantingFertilizerApplication,
  onChangeScriptName,
  onClickScriptConfigViewTrigger,
  onFertilityInputMount,
  onSelectFertilizerProduct,
  onSelectIncorporationMethodForCropProtection,
  onSelectSubstanceType,
  plantingPlanParams,
  products,
  scriptConfigView,
  substanceTypeIsNitrogen,
  scriptType,
  substanceTypeUuid,
  substanceTypes,
  usingLiquidIsChecked,
  validationResult,
  nitrogenApplicationRateType,
  setNitrogenApplicationRateType,
  showNitrogenApplicationRateTypeSwitch
}) => {
  const content = scriptConfigView === scriptConfigViews.SUMMARY ? (
    <ScriptConfigSummary
      applicationType={applicationType}
      nitrogenApplicationRateType={nitrogenApplicationRateType}
      onClickScriptConfigViewTrigger={onClickScriptConfigViewTrigger}
      products={products}
      setNitrogenApplicationRateType={setNitrogenApplicationRateType}
      showNitrogenApplicationRateTypeSwitch={showNitrogenApplicationRateTypeSwitch}
    />
  ) : (
    <ScriptConfigInputs
      displayScriptName={displayScriptName}
      hasNitrapyrin={hasNitrapyrin}
      maxDate={maxDate}
      minDate={minDate}
      onChangeNitrapyrin={onChangeNitrapyrin}
      onChangePlantingFertilizerApplication={onChangePlantingFertilizerApplication}
      onChangeScriptName={onChangeScriptName}
      onClickScriptConfigViewTrigger={onClickScriptConfigViewTrigger}
      onFertilityInputMount={onFertilityInputMount}
      onSelectFertilizerProduct={onSelectFertilizerProduct}
      onSelectIncorporationMethodForCropProtection={onSelectIncorporationMethodForCropProtection}
      onSelectSubstanceType={onSelectSubstanceType}
      plantingPlanParams={plantingPlanParams}
      scriptType={scriptType}
      substanceTypeIsNitrogen={substanceTypeIsNitrogen}
      substanceTypeUuid={substanceTypeUuid}
      substanceTypes={substanceTypes}
      usingLiquidIsChecked={usingLiquidIsChecked}
      validationResult={validationResult}
    />
  );

  return (content);
};
ScriptConfig.propTypes = {
  applicationType: propTypes.string.isRequired,
  displayScriptName: propTypes.string.isRequired,
  hasNitrapyrin: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  onClickScriptConfigViewTrigger: propTypes.func.isRequired,
  onFertilityInputMount: propTypes.func.isRequired,
  onSelectFertilizerProduct: propTypes.func.isRequired,
  onSelectIncorporationMethodForCropProtection: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  products: propTypes.array.isRequired,
  scriptConfigView: propTypes.string.isRequired,
  scriptType: propTypes.string.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypeUuid: propTypes.string, // Null is a valid value to pass indicating no substance type, so can't use .isRequired here.
  substanceTypes: propTypes.object.isRequired,
  usingLiquidIsChecked: propTypes.bool.isRequired,
  validationResult: propTypes.object
};
export default ScriptConfig;
